"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";

// Navegacao em pilula segmentada (trilho borda suave, item ativo branco com sombra leve).
// Feed e Resultados do prototipo ainda nao existem: entram aqui quando as telas forem criadas.

export function NavPrincipal({ itens }: { itens: { href: string; rotulo: string; base?: string }[] }) {
  const caminho = usePathname();
  return (
    <nav aria-label="Area do cliente" className="flex max-w-full gap-0.5 overflow-x-auto rounded-full bg-borda-suave p-0.5">
      {itens.map(({ href, rotulo, base = href }) => {
        const ativo = caminho === base || caminho.startsWith(`${base}/`);
        return (
          <Link
            key={href}
            href={href}
            aria-current={ativo ? "page" : undefined}
            className={cn(
              "rounded-full px-3 py-1 text-13 font-medium whitespace-nowrap transition-colors",
              ativo ? "bg-branco text-texto shadow-ativo" : "text-texto-2 hover:text-marca",
            )}
          >
            {rotulo}
          </Link>
        );
      })}
    </nav>
  );
}
